<script lang="ts">
    import type { CustomSetting } from "..";
    import type { Command, CommandHandler } from "../..";

    import { onMount, setContext } from "svelte";
    import { writable } from "svelte/store";
    import { searchContext } from "../createFilter";
    import { getEntries } from "../..";

    import CommandSetting from "./CommandSetting.svelte";


    let searchElem: HTMLInputElement;
    onMount(() => searchElem.focus());

    export let settings: CustomSetting<string>[];
    export let layout: any;
    export let handler: CommandHandler;

    const globalSearch = searchContext();

    const search = writable("");
    setContext("search", search);

    $: $search = $globalSearch;


    const categories = getEntries(handler.categories).map(([id, category]) => {
        return {
            category: { id, ...category },
            commands: settings.filter(setting => setting.data.category === id)
        }
    }).filter(({ commands }) => commands.length > 0);
</script>

<!----------------------------------------------------------------------------->

<div class="page">
    <label class="input-field search">
        <i>🔍</i>
        <input bind:this={searchElem} type="search" bind:value={$search}>
    </label>
    <div class="commands" class:filter={$search}>
        {#each categories as {category, commands} (category.id)}
            <h3 class="category">{category.name}</h3>
            {#each commands as setting (setting.id)}
                {#if !setting.data.internal}
                    <CommandSetting {setting} />
                {/if}
            {/each}
        {/each}
    </div>
</div>

<!----------------------------------------------------------w------------------->

<style>
    .page {
        height: 100%;

        display: grid;
        grid-template-rows: max-content 1fr;

        & .search {
            margin: 0.5rem;
        }
    }

    .commands {
        display: grid;
        grid-template-columns: 1fr;
        grid-auto-rows: max-content;

        overflow-y: scroll;
        scrollbar-width: thin;
        border-top: 1px solid var(--gap-color);
    }

    .category {
        color: var(--t400);
        margin: 0;
        display: flex;
        grid-column: 1 / -1;
        font-size: 1rem;
        font-weight: 600;
        padding: 0.125rem 0.5rem;
        box-sizing: border-box;
        margin-block: 0.25rem;

        &::after {
            content: "";
            flex: 1;
            border-bottom: 1px solid currentColor;
            margin: auto 0.5rem;
        }
    }

    .filter .category, .commands:has(.editing) .category {
        opacity: 0.5;
    }

    .commands.filter, .commands:has(.editing) {
        background: var(--g50);
    }
</style>
